document.addEventListener('DOMContentLoaded', function () {
  let t, e
  function o() {
    const e = ((o = 1), (s = 9), Math.floor(Math.random() * (s - o)) + o)
    var o, s
    const i = new Date()
    t = i.setHours(i.getHours() + e)
  }
  o(),
    e && clearInterval(e),
    (e = setInterval(function () {
      let e = (function () {
        let e = new Date(),
          s = new Date(t).getTime() - e.getTime()
        s < 0 && (o(), (s = 0))
        let i = Math.floor((s / 36e5) % 24),
          n = Math.floor((s / 6e4) % 60),
          a = Math.floor((s / 1e3) % 60)
        return (
          (i = i >= 10 ? i : '0' + i),
          (n = n >= 10 ? n : '0' + n),
          (a = a >= 10 ? a : '0' + a),
          { hour: i, minute: n, second: a }
        )
      })()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(e.hour),
        $('.sp_top_cut_down .sp_left_view .sp_minute').html(e.minute),
        $('.sp_top_cut_down .sp_left_view .sp_second').html(e.second)
    }, 1e3)),
    new Swiper('.sp-swiper1', {
      autoplay: { disableOnInteraction: !1, delay: 35e5 },
      spaceBetween: 0,
      slidesPerView: 'auto',
      centeredSlides: !0,
      loop: !1
    }),
    new Swiper('.sp-swiper2', {
      autoplay: !0,
      autoplay: { delay: 2500, disableOnInteraction: !1 },
      slideShadows: !0,
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: !0,
      loop: !0,
      pagination: { el: '.sp-pagination', clickable: !0 }
    })
  let s = [
    'https://cdn.shopify.com/s/files/1/0603/2900/1069/files/20250717-p1.png',
    'https://cdn.shopify.com/s/files/1/0603/2900/1069/files/20250717-p2.png',
    'https://cdn.shopify.com/s/files/1/0603/2900/1069/files/20250717-p3.png',
    'https://cdn.shopify.com/s/files/1/0603/2900/1069/files/20250717-p4.png',
    'https://cdn.shopify.com/s/files/1/0603/2900/1069/files/20250717-p5.png'
  ]
  !(function () {
    var t
    $(function () {
      $('#root').css('zoom', 'normal')
      let t = document.body.clientWidth / 1080
      var e
      $('#root').css('zoom', t),
        window.addEventListener('resize', function () {
          e && clearTimeout(e),
            (e = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let t = document.body.clientWidth / 1080
              $('#root').css('zoom', t)
            }, 100))
        })
    }),
      (function () {
        const t = document.querySelectorAll('.lazy-load'),
          e = new IntersectionObserver(
            function (t, o) {
              t.forEach(function (t) {
                if (t.isIntersecting) {
                  const o = t.target,
                    s = o.getAttribute('data-src')
                  ;(o.src = s), e.unobserve(o)
                }
              })
            },
            { rootMargin: '0px 0px 1300px 0px', threshold: 0 }
          )
        t.forEach(function (t) {
          e.observe(t)
        })
      })(),
      (t = s),
      Array.isArray(t[0])
        ? t.forEach(t => {
            t.forEach(t => {
              new Image().src = t
            })
          })
        : t.forEach(t => {
            new Image().src = t
          }),
      document.querySelectorAll('a[href^="#shopping"]').forEach(function (t) {
        t.addEventListener('click', function (t) {
          t.preventDefault()
          const e = document.getElementById('shopping').offsetTop
          let o = $('.time-part').height() + $('.sp-header-top').height()
          window.scroll({ top: e * $('div#root').css('zoom') - o * $('div#root').css('zoom'), behavior: 'smooth' })
        })
      })
    var e = navigator.userAgent || navigator.vendor || window.opera,
      o = /android/i.test(e),
      i = /iPad|iPhone|iPod/.test(e) && !window.MSStream,
      n = !o && !i && !/Iron/.test(e)
    o
      ? console.log('Android')
      : i
      ? console.log('iOS')
      : n
      ? console.log('PC')
      : $('.sp_system').css('letter-spacing', '-4px')
  })()
  let i = window.product
  function n() {
    let t = $('#sp-color div.active').attr('data-val')
    return i.filter(e => e.option1 == t)[0]
  }
  function a() {
    let t = $('#calcNumber').val(),
      e = ((n().price * t) / 100).toFixed(2),
      o = ((n().compare_at_price * t) / 100).toFixed(2)
    ;(e = (e + '').replace('.', ',')),
      (o = (o + '').replace('.', ',')),
      $('#sp_price1').html(e),
      $('#sp_price2').html(o)
    let s = 100 - Math.ceil((n().price / n().compare_at_price) * 100)
    $('.product-part .price-group .sp-row p span').html(s)
  }
  window.cartCount > 0 ? $('#cardNum').removeClass('sp-gray') : $('#cardNum').addClass('sp-gray'),
    $('.sp-btn-style').on('click', function () {
      let t = n().id,
        e = $('#calcNumber').val()
      window.location.href = '/cart/' + t + ':' + e
    }),
    $('.sp-reduce').click(function () {
      let t = $(this).siblings('input')[0],
        e = Number(t.value) - 1
      e > 0 && (t.value = e), a()
    }),
    $('.sp-add').click(function () {
      let t = $(this).siblings('input')[0],
        e = Number(t.value) + 1
      ;(t.value = e), a()
    }),
    $('.sp-option').click(function () {
      $(this).siblings().removeClass('active'), $(this).addClass('active')
      let t = $('#sp-color .sp-option.active').index()
      ;($('.product-part .sp-img-p')[0].src = s[t]),
        0 == t
          ? $('.product-part .sp-img-p').css('width', 476)
          : 1 == t
          ? $('.product-part .sp-img-p').css('width', 641)
          : 2 == t
          ? $('.product-part .sp-img-p').css('width', 910)
          : 3 == t
          ? $('.product-part .sp-img-p').css('width', 834)
          : $('.product-part .sp-img-p').css('width', 935),
        a()
    }),
    $(function () {
      $('.cart-btn').click(function () {
        $(this).children('img').addClass('on'),
          $('.sp-header-top .sp-cart .num').show(),
          setTimeout(function () {
            $('.cart-btn').children('img').removeClass('on')
          }, 500),
          $('.sp-header-top .sp-cart').addClass('on'),
          setTimeout(function () {
            $('.sp-header-top .sp-cart').removeClass('on')
          }, 500)
      })
      let t = 0
      $('.product-part .cart-btn').click(function () {
        let e = { id: n().id, quantity: $('#calcNumber').val() }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: e,
          success: function () {
            $.getJSON(window.Shopify.routes.root + 'cart.js', function (t) {
              $('#cardNum').html(t.item_count), $('#cardNum').removeClass('sp-gray')
            })
          },
          dataType: 'json'
        })
        let o = $('.product-part #calcNumber')[0].value
        ;(t += Number(o)), $('#cardNum').html(t), $('#cardNum').removeClass('sp-gray')
        var s = $('.product-part .sp-img-p'),
          i = s[0].cloneNode(!0)
        i.classList.add('sp_clone'),
          $('.product-part').append(i),
          $('.sp_clone').css({
            width: s[0].width,
            height: s[0].height,
            background: '#e7e9ef',
            position: 'fixed',
            top: s[0].offsetTop,
            left: s.offset().left,
            'z-index': '99'
          })
        let a = $('.sp-cart')
        $('.sp_clone').animate(
          {
            top: a[0].offsetTop + $('.time-part').height(),
            left: a[0].offsetLeft + a.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4
          },
          500,
          'linear',
          function () {
            $(this).animate({ width: 0, height: 0, opacity: 0 }, 0, function () {
              $(this).detach()
            })
          }
        )
      })
    })
  const r = document.getElementsByClassName('gradually')
  for (let t of r) {
    const e = t.querySelectorAll('span'),
      o = t.querySelector('.sp-detail'),
      s = new IntersectionObserver(
        i => {
          i.forEach(i => {
            if (i.isIntersecting) {
              e.forEach((t, e) => {
                ;(t.style.animation = 'swift-up-fade 0.5s ease forwards'), (t.style.animationDelay = 0.1 * e + 's')
                const o = t.querySelector('i')
                o &&
                  ((o.style.animation = 'swift-up-fade 0.5s ease forwards'), (o.style.animationDelay = 0.1 * e + 's'))
              })
              const i = 0.1 * e.length + 0.3
              o && ((o.style.animation = 'swift-up-fade 0.5s ease forwards'), (o.style.animationDelay = `${i}s`)),
                s.unobserve(t)
            }
          })
        },
        { threshold: 0.3 }
      )
    s.observe(t)
  }
})
